import { convertArrayToApiFormat } from '~/utils/convert-array-api-format';
import { AcquisitionRequestError } from './types';
import type { ResultError, ResultSuccess, FormData } from './types';

type MutationPostForm = (data: FormData) => Promise<ResultSuccess>;

const URL_POST_FORM = `${process.env.API_GATEWAY}/acquisition/forms`;

export const mutationPostForm: MutationPostForm = async (data) => {
  const response = await fetch(URL_POST_FORM, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      'X-Tenant-Id': 'creditasbr',
    },
    body: JSON.stringify({
      type: data.type.toUpperCase(),
      product: data.product.toUpperCase(),
      attributes: convertArrayToApiFormat(data.attributes),
      origin: window.location.href,
    }),
  });

  const resultAny: any = await response.json();

  if (response.ok) {
    const result: ResultSuccess = resultAny;
    return result;
  } else {
    const result: ResultError = resultAny;
    const error = AcquisitionRequestError.fromResult(result);
    return Promise.reject(error);
  }
};
